var _path, _path2, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIHelp = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.0008C24 18.6272 18.6278 24 12.0012 24C5.37372 24 0 18.6272 0 12.0008C0 5.37278 5.37372 0 12.0012 0C18.6278 0 24 5.37278 24 12.0008ZM11.9988 14.3832C11.275 14.3832 10.6851 13.7964 10.6851 13.0702C10.6851 12.3456 11.275 11.7588 11.9988 11.7588C13.0801 11.7588 13.961 10.8771 13.961 9.79437C13.961 8.71473 13.0801 7.833 11.9988 7.833C10.9169 7.833 10.0382 8.71473 10.0382 9.79437C10.0382 10.5205 9.44752 11.1089 8.72363 11.1089C7.9982 11.1089 7.41139 10.5205 7.41139 9.79437C7.41139 7.26623 9.46985 5.20706 11.9988 5.20706C14.5286 5.20706 16.5878 7.26623 16.5878 9.79437C16.5878 12.3256 14.5286 14.3832 11.9988 14.3832ZM12.0154 15.6225C12.7408 15.6286 13.3261 16.2362 13.3107 16.9609C13.293 17.6909 12.6962 18.2638 11.9677 18.2469C11.2476 18.2338 10.6716 17.6231 10.687 16.8931C10.7032 16.1862 11.2977 15.6132 12.0154 15.6225Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3864_240",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.0008C24 18.6272 18.6278 24 12.0012 24C5.37372 24 0 18.6272 0 12.0008C0 5.37278 5.37372 0 12.0012 0C18.6278 0 24 5.37278 24 12.0008ZM11.9988 14.3832C11.275 14.3832 10.6851 13.7964 10.6851 13.0702C10.6851 12.3456 11.275 11.7588 11.9988 11.7588C13.0801 11.7588 13.961 10.8771 13.961 9.79437C13.961 8.71473 13.0801 7.833 11.9988 7.833C10.9169 7.833 10.0382 8.71473 10.0382 9.79437C10.0382 10.5205 9.44752 11.1089 8.72363 11.1089C7.9982 11.1089 7.41139 10.5205 7.41139 9.79437C7.41139 7.26623 9.46985 5.20706 11.9988 5.20706C14.5286 5.20706 16.5878 7.26623 16.5878 9.79437C16.5878 12.3256 14.5286 14.3832 11.9988 14.3832ZM12.0154 15.6225C12.7408 15.6286 13.3261 16.2362 13.3107 16.9609C13.293 17.6909 12.6962 18.2638 11.9677 18.2469C11.2476 18.2338 10.6716 17.6231 10.687 16.8931C10.7032 16.1862 11.2977 15.6132 12.0154 15.6225Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3864_240)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_help.a1e2a59d.svg";
export { ForwardRef as ReactComponent };